import React__default from 'react';
import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useThemeColors } from '../../providers/themeColors/hook.js';

var PREFIX = "SearchPageHeaderLayout";
var classes = {
    root: "".concat(PREFIX, "-root"),
    searchInputContainer: "".concat(PREFIX, "-searchInputContainer"),
    actionsBar: "".concat(PREFIX, "-actionsBar"),
    breadcrumbs: "".concat(PREFIX, "-breadcrumbs"),
    input: "".concat(PREFIX, "-input"),
    show: "".concat(PREFIX, "-show"),
    hide: "".concat(PREFIX, "-hide")
};
var StyledSearchPageHeaderLayout = styled(Box)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.root)] = {
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            position: "relative",
            transition: "0.5s"
        },
        _b["& .".concat(classes.searchInputContainer)] = (_c = {},
            _c[theme.breakpoints.up("sm")] = {
                paddingBottom: theme.spacing(1),
                paddingTop: theme.spacing(1)
            },
            _c),
        _b["& .".concat(classes.actionsBar)] = {},
        _b["& .".concat(classes.breadcrumbs)] = {
            backgroundColor: theme.palette.grey[200]
        },
        _b["& .".concat(classes.input)] = {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(0.5),
            marginInline: "auto",
            width: "calc(100% - 80px)",
            overflow: "hidden",
            "& .MuiOutlinedInput-root": {
                borderRadius: theme.spacing(1)
            },
            "& .MuiOutlinedInput-input": (_d = {
                    height: "inherit",
                    padding: theme.spacing(0.5, 0, 0.625, 1.5)
                },
                _d[theme.breakpoints.up("sm")] = {
                    padding: theme.spacing(0.875, 0, 1, 2)
                },
                _d)
        },
        _b["& .".concat(classes.show)] = {
            visibility: "visible",
            opacity: 1,
            transition: "visibility 1.5s, opacity 1.5s"
        },
        _b["& .".concat(classes.hide)] = {
            visibility: "hidden",
            opacity: 0,
            height: 0,
            padding: 0,
            margin: 0,
            transition: "visibility 0.2s, opacity 0.2s"
        },
        _b);
});
var SearchPageHeaderLayout = function (_a) {
    var searchInput = _a.searchInput, searchBreadcrumbs = _a.searchBreadcrumbs, actionsBar = _a.actionsBar, showBackgroundUrl = _a.showBackgroundUrl, backgroundUrl = _a.backgroundUrl, backgroundColor = _a.backgroundColor, searchInputRenderLayout = _a.searchInputRenderLayout;
    var convertColor = useThemeColors().convertColor;
    var searchInputLayout = searchInputRenderLayout ? (searchInputRenderLayout(searchInput)) : (React__default.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
        React__default.createElement(Grid, { item: true, xs: 11, sm: 8, md: 7, lg: 6, xl: 5, className: classes.searchInputContainer },
            React__default.createElement(Box, { className: classes.input }, searchInput))));
    return (React__default.createElement(StyledSearchPageHeaderLayout, { "data-testid": "KFSearchHeaderLayout", className: classes.root, style: {
            backgroundImage: showBackgroundUrl && backgroundUrl ? "url(".concat(backgroundUrl, ")") : "",
            backgroundColor: backgroundColor ? convertColor(backgroundColor) : "black"
        } },
        searchInput && searchInputLayout,
        searchBreadcrumbs && React__default.createElement(Box, { className: classes.breadcrumbs }, searchBreadcrumbs),
        React__default.createElement(Box, { className: classes.actionsBar }, actionsBar)));
};

export { SearchPageHeaderLayout as default };
//# sourceMappingURL=SearchPageHeaderLayout.js.map
